import axios from "axios";
import { PARTY_DISCOUNTS } from "../../types/PartyDiscountType";

const getAllPartyDiscount = (data) => {
	return {
		type: PARTY_DISCOUNTS,
		payload: data,
	};
};

export const loadAllPartyDiscount = ({ page, limit }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const { data } = await axios.get(
				`product-currency?page=${page}&count=${limit}`
			);
			//dispatching data
			dispatch(getAllPartyDiscount(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};
